import type {
  TripRead,
} from 'src/common/external/bambi-api/bambiApi';
import type {
  TripSubscriptionRead,
} from 'src/common/external/bambi-api/tripsApi';

export const generateSubscriptionFromTrip = (
  trip: TripRead
): TripSubscriptionRead => {
  return {
    ...trip,
    id: '',
    expires_at: '',
    recurrences: [],
    start_date: '',
    old_trips: [],
    new_trips: [],
    load_time_seconds: trip.load_time_seconds ?? undefined,
    unload_time_seconds: trip.unload_time_seconds ?? undefined,
    estimated_distance_miles: undefined,
    pickup_wait_time_seconds: undefined,
    payer_passenger: {
      id: '',
      external_id: '',
      authorization_id: '',
    },
  };
};
